export const MAX_AGENDA_FILE_SIZE = 20 * 1000 * 1000; // 20MB
export const MAX_AGENDA_FILE_SIZE_AS_STRING = '20MB';
